export const setUser = (email, type) => ({ type, payload: email });
export const setPassword = (password, type) => ({ type, payload: password });
